export const reportSeverities = [0, 10, 20, 30] as const;

const reportSeverityKeys = reportSeverities.map((s) => s.toString());

export type ReportId = string;

export type ReportSeverity = (typeof reportSeverities)[number];

export type ReportSeverityKey = `${ReportSeverity}`;

export const isReportSeverityKey = (
  severity: string,
): severity is ReportSeverityKey => {
  return reportSeverityKeys.includes(severity);
};

export type ReportSeverityResults = Record<ReportSeverity, number>;

export type ReportSeverityDescriptions = Record<ReportSeverity, string>;

export const INTENT_RULE_NAME_MAX_LENGTH = 64;
export const INTENT_RULE_DESCRIPTION_MAX_LENGTH = 350;
export const INTENT_RULE_CHECK_DESCRIPTION_MAX_LENGTH = 150;
